import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class SeibiExtremeService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();
  constructor() {
  }

  get headers() {
    return {
      'Content-Type': 'application/json',
      'auth': localStorage.getItem('token'),
    };
  }

  public getExtremeWorks() {
    return this.commonService.get(`${this.baseAPI}/admin/extreme/works`);
  }

  public getExtremeWorkLink(versionId = 0) {
    let q = "";
    if (versionId) {
      q = "?version=" + versionId;
    }
    return this.commonService.get(`${this.baseAPI}/admin/extreme/works-link${q}`);
  }

  public saveExtremeWorkLink(data: any) {
    return this.commonService.post(`${this.baseAPI}/admin/extreme/works-link`, data);
  }

  public deleteExtremeWorkLink(data: any) {
    return this.commonService.delete(`${this.baseAPI}/admin/extreme/works-link`, data);
  }

  public async saveExtremeKousuu(data: any) {
    const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/extreme/seibi-kousuu`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'saveExtremeKousuu');
      return;
    }
  }

  public getBuhinLink() {
    return this.commonService.get(`${this.baseAPI}/admin/extreme/part-selection-buhin`);
  }

  public getExtremeBuhin() {
    return this.commonService.get(`${this.baseAPI}/admin/extreme/buhins`);
  }

  public async saveWorkName(data: any, isExtreme: boolean) {
    const path = isExtreme ? "custom-work-extreme" : "custom-work-shaken";
    const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/extreme/${path}`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'saveWorkName');
      return;
    }
  }

  public async deleteWorkName(data: any, isExtreme: boolean) {
    const path = isExtreme ? "custom-work-extreme" : "custom-work-shaken";
    const { result, error } = await this.commonService.delete(`${this.baseAPI}/admin/extreme/${path}`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'deleteWorkName');
      return;
    }
  }

  public async saveExtremeBuhinLink(data: any) {
    const { result, error } = await this.commonService.post(`${this.baseAPI}/admin/extreme/buhin-link`, data);
    if (result) {
      return result.status;
    } else if (error) {
      return error.status;
    }
  }

  public async deleteExtremeBuhinLink(data: any) {
    const { result, error } = await this.commonService.delete(`${this.baseAPI}/admin/extreme/buhin-link`, data);
    if (result) {
      return result.status;
    } else if (error) {
      return error.status;
    }
  }

  public async saveBuhinName(data: any, isExtreme: boolean) {
    const path = isExtreme ? "custom-buhin-extreme" : "custom-buhin-shaken";
    const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/extreme/${path}`, data);
    if (result) {
      return result.status;
    } else if (error) {
      return error.status;
    }
  }

  public async deleteBuhinName(data: any, isExtreme: boolean) {
    const path = isExtreme ? "custom-buhin-extreme" : "custom-buhin-shaken";
    const { result, error } = await this.commonService.delete(`${this.baseAPI}/admin/extreme/${path}`, data);
    if (result) {
      return result.status;
    } else if (error) {
      return error.status;
    }
  }

  // async getHanyouSeibiVersion() {
  //   const { result, error } = await this.commonService.get(`${this.baseAPI}/admin/hanyou-seibi-version`);
  //   if (result) {
  //     return {
  //       groupCd: result.headers.login_group_code || "",
  //       shatenCd: result.headers.login_shaten_code || "", versions: result.data
  //     };
  //   } else if (error) {
  //     return { versions: [] };
  //   }
  // }

  private async addNewItem(path: string, data: any) {
    const { result, error } = await this.commonService.post(`${this.baseAPI}/admin/${path}`, data);
    let status;
    let res = {};
    if (result) {
      status =  result.status;
      res = result.data;
    } else if (error) {
      status =  error.status;
    }
    return { status, ...res };
  }

  async addCategory(data: any) {
    return await this.addNewItem("extreme/works-link/category", data);
  }

  async addInspection(data: any) {
    return await this.addNewItem("extreme/works-link/inspect-work", data);
  }

  async addSeibi(data: any) {
    return await this.addNewItem("inspect-seibi", data);
  }

  async getWorkCd(versionId: number) {
    const { result } = await this.commonService.get(`${this.baseAPI}/seibi/max/workcd?versionId=${versionId}`);
    if (result && result.data && result.data.workCd) {
      return result.data.workCd;
    }
    return "";
  }

  async getInspectCd(versionId: number, inspectType: number) {
    const q = `?versionId=${versionId}&inspectType=${inspectType}`;
    const { result } = await this.commonService.get(`${this.baseAPI}/seibi/max/inspectcd${q}`);
    if (result && result.data && result.data.inspectCd) {
      return result.data.inspectCd;
    }
    return "";
  }

  async updateCategory(data: any) {
    return await this.addNewItem("extreme/works-link/update-category", data);
  }

  async addInspectDescription(data: any) {
    return await this.addNewItem("extreme/works-link/inspect-description", data);
  }

  async addRecommendInspectSeibi(data: any) {
    return await this.addNewItem("extreme/works-link/recommend-inspect-seibi", data);
  }

  public deleteMSknInspectDescription(data: any) {
    return this.commonService.delete(`${this.baseAPI}/admin/extreme/works-link/delete-inspect-description`, data);
  }

  public deleteMSknRecommendInspectSeibi(data: any) {
    return this.commonService.delete(`${this.baseAPI}/admin/extreme/works-link/delete-recommend-inspect-seibi`, data);
  }

  async updateInspectDescriptionOrder(data: any[]) {
    return await this.addNewItem("extreme/works-link/inspect-description-order", data);
  }

  async updateRecommendInspectSeibiOrder(data: any[]) {
    return await this.addNewItem("extreme/works-link/recommend-inspect-seibi-order", data);
  }

  /** 2021-08-03 sh #7329 implements delete [START] */
  public deleteInspection(data: any) {
    return this.commonService.delete(`${this.baseAPI}/admin/extreme/delete-inspection`, data);
  }
  public deleteSubCategory(data: any) {
    return this.commonService.delete(`${this.baseAPI}/admin/extreme/delete-sub-category`, data);
  }
  public deleteMidCategory(data: any) {
    return this.commonService.delete(`${this.baseAPI}/admin/extreme/delete-mid-category`, data);
  }
  /** 2021-08-03 sh #7329 implements delete [END] */

  public getJizenVal() {
    return this.commonService.get(`${this.baseAPI}/jizen-val`);
  }

  public addExtremeSeibi(datas: any[]) {
    return this.addNewItem("extreme-works", datas);
  }
  public deleteInspectSeibiLink(data: any) {
    return this.commonService.delete(`${this.baseAPI}/admin/delete-extreme-work`, data);
  }
}
